import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Blockquote",
  inserter: true,
  icon: "format-quote",
  category: "text",
  tags: ["#subpage"],
  flags: {
    contentWidth: true,
  },
}

export default defineBlock("content/blockquote", (props) => {
  return (
    <div>
      <div
        className={cn(
          "stack-y-5 my-8",
          !env.admin && "md:ml-[calc(0px-var(--tw-grid-col-width)-var(--tw-grid-gutter))]",
        )}
      >
        <EditableText
          store="content"
          className="type-title-l text-pretty relative"
          as="div"
          placeholder="Enter a quote"
        />
        <EditableText store="attribution" className="type-label-caps" as="div" placeholder="Enter attribution" />
      </div>
    </div>
  )
})
